// admins/car-list
import React from 'react';
import View from 'src/pages/admins/cars/list';
import { PaginationProvider } from 'src/contexts/pagination-context';
import { useItemsSearch, useItemsIds, carsApi } from 'src/api/cars/vm-view';

const Page = () => {
  const search = useItemsSearch();
  const store = carsApi.getItemAll(search.state);
  const ids = useItemsIds(store.items);

  return (
    <PaginationProvider endpoint={store.endpoint} keyword={store.query}>
      <View dataSearch={search} dataStore={store} dataIds={ids} />
    </PaginationProvider>
  );
};

export default Page;
